import {
  ITraTienSinhVienDotFilterRequest,
  ITraTienSinhVienDotSaveRequest,
  ITraTienSinhVienExportRequest,
  ITraTienSinhVienHocPhanRequest,
  ITraTienSinhVienKhoaRequest,
  ITraTienSinhVienSaveRequest,
  ITraTienSinhVienThietLapInRequest,
  ITraTienSinhVienTraCuuRequest,
} from "../../model/request/bao-cao/ITraTienSinhVienRequest";
import { apiClient } from "../apiClient";

const ENDPOINT = "tra-tien-sinh-vien";

export const traTienSinhVienApi = {
  SelectDot: (request: ITraTienSinhVienDotFilterRequest) =>
    apiClient.post(`${ENDPOINT}/dot/select`, request),
  SaveDot: (request: ITraTienSinhVienDotSaveRequest) =>
    apiClient.post(`${ENDPOINT}/dot/save`, request),
  DeleteDot: (id: number) => apiClient.post(`${ENDPOINT}/dot/delete/${id}`, {}),
  SetKhoa: (request: ITraTienSinhVienKhoaRequest) =>
    apiClient.post(`${ENDPOINT}/dot/khoa`, request),
  LuuThietLapIn: (request: ITraTienSinhVienThietLapInRequest) =>
    apiClient.post(`${ENDPOINT}/dot/thiet-lap-in`, request),

  SelectChiTiet: (id_dot: number) =>
    apiClient.post(`${ENDPOINT}/chi-tiet/${id_dot}`, {}),
  SaveChiTiet: (request: ITraTienSinhVienSaveRequest) =>
    apiClient.post(`${ENDPOINT}/chi-tiet/save`, request),

  /** Tra các cột còn lại của bảng kê từ ba cột của tệp Excel. */
  TraCuu: (request: ITraTienSinhVienTraCuuRequest) =>
    apiClient.post(`${ENDPOINT}/tra-cuu`, request),

  /** Các học phần của một sinh viên để chọn khi thêm dòng. */
  SelectHocPhan: (request: ITraTienSinhVienHocPhanRequest) =>
    apiClient.post(`${ENDPOINT}/hoc-phan`, request),

  SelectLog: (id_dot: number) =>
    apiClient.post(`${ENDPOINT}/lich-su/${id_dot}`, {}),

  ExportExcel: (request: ITraTienSinhVienExportRequest) =>
    apiClient.post(`${ENDPOINT}/export-excel`, request),
  /** Bản xem trước (HTML dựng từ chính tệp Excel sẽ xuất) — màn Thiết lập in và nút In. */
  XemTruoc: (request: ITraTienSinhVienExportRequest) =>
    apiClient.post(`${ENDPOINT}/xem-truoc`, request),
};
